import { jsx as a, jsxs as b } from "react/jsx-runtime";
import { Slot as j } from "@radix-ui/react-slot";
import { useComposedRefs as v } from "@telegraph/compose-refs";
import { Box as h } from "@telegraph/layout";
import { Text as T } from "@telegraph/typography";
import d from "clsx";
import l from "react";
const n = {
  Container: {
    1: "h-6 pl-0 rounded-2",
    2: "h-8 pl-0 rounded-2",
    3: "h-10 pl-0 rounded-3"
  },
  Input: {
    1: "px-1",
    2: "px-2",
    3: "px-3"
  },
  Text: {
    1: "1",
    2: "2",
    3: "3"
  },
  Slot: {
    1: "[&>[data-tgph-button]]:rounded-1",
    2: "[&>[data-tgph-button]]:rounded-1",
    3: "[&>[data-tgph-button]]:rounded-2"
  },
  SlotLeading: {
    1: "order-1 pl-1",
    2: "order-1 pl-2",
    3: "order-1 pl-3"
  },
  SlotTrailing: {
    1: "order-3 pr-1",
    2: "order-3 pr-2",
    3: "order-3 pr-3"
  }
}, q = {
  Container: {
    default: {
      outline: "bg-surface-1 border-gray-6 hover:border-gray-7 focus-within:!border-blue-8",
      ghost: "bg-transparent border-transparent hover:bg-gray-3 focus-within:!bg-gray-4 focus-within:!border-blue-8"
    },
    disabled: {
      outline: "cursor-not-allowed bg-gray-2 border-gray-2 [&_[data-tgph-icon]]:text-gray-8 placeholder:text-gray-9 [&>input]:text-gray-9",
      ghost: "cursor-not-allowed bg-transparent border border-transparent [&_[data-tgph-icon]]:text-gray-8 placeholder:text-gray-9 [&>input]:text-gray-9"
    },
    error: {
      outline: "bg-surface-1 border-red-6",
      ghost: "bg-transparent border-red-6"
    }
  }
}, f = l.createContext({
  state: "default",
  size: "2",
  variant: "outline"
}), x = ({
  as: r = "input",
  size: t = "2",
  variant: e = "outline",
  textProps: o = { size: n.Text[t], color: "default" },
  className: m,
  disabled: u,
  errored: w,
  children: S,
  tgphRef: R,
  ...C
}) => {
  const z = r, i = l.useRef(null), I = v(R, i), p = u ? "disabled" : w ? "error" : "default";
  return /* @__PURE__ */ a(f.Provider, { value: { size: t, variant: e, state: p }, children: /* @__PURE__ */ b(
    h,
    {
      className: d(
        "box-border flex items-center transition-all",
        "border-[1px] border-solid text-gray-12 placeholder:text-gray-10",
        q.Container[p][e],
        n.Container[t]
      ),
      onPointerDown: (c) => {
        if (c.target.closest("button, a")) {
          c.preventDefault();
          return;
        }
        const g = i.current;
        g && requestAnimationFrame(() => {
          g.focus();
        });
      },
      children: [
        /* @__PURE__ */ a(
          T,
          {
            as: z,
            className: d(
              "appearance-none border-none shadow-0 outline-0 bg-transparent",
              "[font-family:inherit] h-full w-full",
              "order-2",
              n.Input[t],
              m
            ),
            disabled: u,
            ...o,
            ...C,
            tgphRef: I
          }
        ),
        S
      ]
    }
  ) });
}, s = l.forwardRef(
  ({ position: r = "leading", ...t }, e) => {
    const o = l.useContext(f);
    return /* @__PURE__ */ a(
      h,
      {
        className: d(
          "group box-border flex items-center justify-center h-full",
          "[&>[data-tgph-button]]:w-full [&>[data-tgph-button]]:h-auto",
          // Overrides to match the icon button in figma
          "[&>[data-tgph-button-layout='icon-only']]:aspect-square [&>[data-tgph-button-layout='icon-only']]:p-0",
          // Overrides default button layout to match the button in figma
          "[&>[data-tgph-button-layout='default']]:px-2",
          // If only an icon button is present, set the aspect ratio to square
          "[&:has([data-tgph-button-layout='icon-only'])]:aspect-square",
          // If only an icon button is present, reset the padding to spacing-1
          "[&:has([data-tgph-button-layout='icon-only'])]:!p-1",
          r === "leading" && n.SlotLeading[o.size],
          r === "trailing" && n.SlotTrailing[o.size],
          n.Slot[t.size ?? o.size]
        ),
        children: /* @__PURE__ */ a(j, { size: o.size, ...t, ref: e })
      }
    );
  }
), y = ({
  LeadingComponent: r,
  TrailingComponent: t,
  ...e
}) => /* @__PURE__ */ b(x, { ...e, children: [
  r && /* @__PURE__ */ a(s, { position: "leading", children: r }),
  t && /* @__PURE__ */ a(s, { position: "trailing", children: t })
] });
Object.assign(y, { Root: x, Slot: s });
const E = y;
export {
  E as Input
};
//# sourceMappingURL=index.mjs.map
